// extracted by mini-css-extract-plugin
export default {"link":"mE-z","disabled":"nE-z"};